<div class="flex flex-column h-full">
  <div class="flex" style="height: auto">
    <div class="flex flex-grow-1 align-items-center justify-content-start">
      <h2 class="module-title">{{ title | translate | uppercase }}</h2>
    </div>
  </div>
  <p-divider styleClass="divider-slim"></p-divider>
  <div class="flex flex-grow-1 h-full">
    <div class="flex w-12 relative">
      <div class="absolute h-full w-full">
        <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
          <app-module-menu [menuItems]="menuItems"></app-module-menu>
        </p-scrollPanel>
      </div>
    </div>
  </div>
</div>
